import type { WithContext, Product } from 'schema-dts'
import type { ESPokemonSingleProduct } from '@ka-nabellinc/tcg-platform-es-schema'
import { getPokemonSingleProductInfoString } from '@/utils/pokemon'

export const getPokemonSingleProductSchema = (product: ESPokemonSingleProduct) => {
  const inventories = [
    product.rank_s_inventory,
    product.rank_a_inventory,
    product.rank_b_inventory,
    product.rank_c_inventory,
  ]
  const isInStock = inventories.some(i => !!i.inventory_num)

  const googleSchema: WithContext<Product> = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: getPokemonSingleProductInfoString(product),
    image: product.pm_card.card_image1_url,
    description: '',
    sku: product.inventory_product_id,
    brand: {
      '@type': 'Brand',
      name: 'カーナベル',
      logo: 'https://assets.ka-nabell.com/common/logo.png',
      slogan: 'ポケカ販売ならカーナベル！',
      url: 'https://sell.ka-nabell.com/pokemon'
    },
    offers: {
      '@type': 'Offer',
      url: `https://sell.ka-nabell.com/pokemon/single/${product.inventory_product_id}`,
      priceSpecification: {
        '@type': 'PriceSpecification',
        price: product.rank_c_inventory.selling_price,
        minPrice: product.rank_c_inventory.selling_price,
        maxPrice: product.rank_s_inventory.selling_price,
        priceCurrency: 'JPY'
      },
      itemCondition: "https://schema.org/UsedCondition",
      availability: isInStock ? "https://schema.org/InStock" : 'https://schema.org/OutOfStock',
      shippingDetails: {
        "@type": "OfferShippingDetails",
        shippingRate: {
          "@type": "MonetaryAmount",
          currency: "JPY",
          minValue: 0,
          maxValue: 1200
        },
        shippingDestination: {
          "@type": "DefinedRegion",
          addressCountry: "JP"
        },
        deliveryTime: {
          "@type": "ShippingDeliveryTime",
          handlingTime: {
            "@type": "QuantitativeValue",
            "minValue": 0,
            "maxValue": 1,
            "unitCode": "DAY"
          },
          transitTime: {
            "@type": "QuantitativeValue",
            minValue: 1,
            maxValue: 2,
            unitCode: "DAY"
          }
        }
      }
    },
  }

  return googleSchema
}
